<template>
  <div>
      <h1>Voucher</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>